export default __webpack_public_path__ + "static/media/opredelenie-pobeditelya.d2179db1.pdf";